import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidadoresService {

  constructor() { }

  //Validacion para input fecha...
  fechaNoAdecuada(control: FormControl): { [nombreError: string]: boolean } {

    var valorFecha = control.value;

    if (valorFecha == 0 || !valorFecha) {

      return {
        fechaNoExistente: true
      }
    }

    //La validación pasa, por lo tanto...
    return null;
  }

  //Validacion para input  numero factura...
  numeroFacturaAdecuado(control: FormControl): { [nombreError: string]: boolean } {

    var valorNumeroFactura = control.value;

    if (!valorNumeroFactura || valorNumeroFactura == "") {

      return {
        numeroFactNoExiste: true
      }
    }

    return null;
  }

  //Validacion para input de cifCliente...
  customerCifAdecuado(control: FormControl): { [nombreError: string]: boolean } {

    var cifCustomerFactura = control.value;

    if (!cifCustomerFactura || cifCustomerFactura == "") {

      return {
        cifCustomerNoExiste: true
      }
    }

    return null;
  }

  //Validacion para input de nombreCliente...
  cistomerNameAdecuado(control: FormControl): { [nombreError: string]: boolean } {

    var nombreCustomerFactura = control.value;

    if (!nombreCustomerFactura || nombreCustomerFactura == "") {

      return {
        nombreCustomerNoExiste: true
      }
    }

    return null;
  }

  //Validacion totalFactura...
  totalFacturaAdecuado(control: FormControl): { [nombreError: string]: boolean } {

    var totalFactura = Number(control.value);

    if (totalFactura == 0) {

      return {
        totalFacturaIgual0: true
      }
    }

    return null;
  }

}
